import { UpdateFileConfig } from "./UpdateFileConfig";
import { User } from "modules/login/models/User";
import { default as firebase } from "common/Firebase";
import { TFirestoreTimestamp } from "common/types/FirebaseTypes";
import { IUsers } from "common/interfaces";

/**
 * Modelo de projetos.
 * @category Developments
 * @interface Development
 * @hideconstructor
 */
export class Development {
  /** Nome do projeto. */
  name: string;
  /** Endereço da obra. */
  address: string;
  /** Status do projeto. Só encontrei o valor 'open'. */
  status: string;
  /** Usuários com permissão de acesso ao projeto. </br>
   * 0 - Administrador </br>
   * 1 - Leitura e edição </br>
   * 2 - Somente leitura
   */
  users: IUsers;
  /** Nome do usuário proprietário. */
  ownerName: string;
  /** URL da foto de perfil do usuário proprietário. */
  ownerPhoto: string;
  /** URL da imagem de capa do projeto. */
  image?: string;
  /** Nome da imagem de capa do projeto. */
  imageName?: string;
  /** Data de criação do projeto. */
  createAt?: TFirestoreTimestamp;
  /** Data de modificação do projeto. */
  modifyAt?: TFirestoreTimestamp;
  /** Lista com algumas informações dos usuários compartilhados. */
  sharedUsers?: Array<User>;
  /** Flag que sinaliza a versão em que o projeto está.
   * Esta propriedade foi criada com o intuito de ajudar na transição para novas funcionalidades implementadas em 2021.
   * @deprecated
   */
  version?: number;
  /** Flag que sinaliza que o projeto foi criado a partir da implementação do novo visualizador 3D Xeokit.
   * Implementado em mai/22.
   */
  isXeokitViewer?: boolean;
  /** Flag que sinaliza se o projeto está passando pela refatoração para versão 2.
   * @deprecated
   */
  refactoring?: boolean | firebase.firestore.FieldValue;
  /** Objeto que armazenava as configurações de colunas obrigatórias e colunas customizadas do projeto ao importar uma planilha.
   * Foi transferido para o usuário.
   * @deprecated
   */
  updateFileConfig?: UpdateFileConfig;

  constructor(
    name: string,
    address: string,
    status,
    users: IUsers,
    ownerName: string,
    ownerPhoto: string,
    createAt?: TFirestoreTimestamp,
    modifyAt?: TFirestoreTimestamp,
    image: string = "",
    imageName: string = "",
    sharedUsers?: Array<User>,
    version?: number,
    isXeokitViewer?: boolean,
    refactoring?: boolean,
    updateFileConfig?: UpdateFileConfig
  ) {
    this.name = name;
    this.address = address;
    this.status = status;
    this.users = users;
    this.ownerName = ownerName;
    this.ownerPhoto = ownerPhoto;
    this.image = image;
    this.imageName = imageName;
    this.createAt = createAt;
    this.modifyAt = modifyAt;
    this.sharedUsers = sharedUsers;
    this.version = version;
    this.isXeokitViewer = isXeokitViewer;
    this.refactoring = refactoring;
    this.updateFileConfig = updateFileConfig;
  }

  public static getDefault(): Development {
    return new Development("", "", "open", {}, "", "");
  }
}



// WEBPACK FOOTER //
// ./src/modules/development/models/Development.ts